import { ERROR_MESSAGES } from "constants/errorMessages";
import { getLocaleForCurrencyCode } from "utils/countryMappings";

export const formatCurrency = (amount, { currencyCode, locale } = {}) => {
  if (!currencyCode) {
    throw new Error(ERROR_MESSAGES.CURRENCY_FORMAT_MISSING_OPTIONS);
  }

  const resolvedLocale = locale || getLocaleForCurrencyCode(currencyCode);
  const numericAmount = Number(amount) || 0;

  return new Intl.NumberFormat(resolvedLocale, {
    style: "currency",
    currency: currencyCode,
    currencyDisplay: "code",
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(numericAmount);
};
